module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component component-backoffice-deposit-configuration"
  }, _vm._l((_vm.validations), function(validation, label) {
    return _c('div', {
      staticClass: "field"
    }, [_c('div', {
      staticClass: "column"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (validation.active),
        expression: "validation.active"
      }],
      attrs: {
        "id": (_vm._uid + "-" + label),
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(validation.active) ? _vm._i(validation.active, null) > -1 : (validation.active)
      },
      on: {
        "change": function($event) {
          var $$a = validation.active,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(validation, "active", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(validation, "active", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(validation, "active", $$c)
          }
        }
      }
    }), _c('label', {
      attrs: {
        "for": (_vm._uid + "-" + label)
      }
    }, [_vm._v(_vm._s(label))])]), _c('div', {
      staticClass: "column"
    }, [(label === 'default' && validation.active) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (validation.value),
        expression: "validation.value"
      }],
      attrs: {
        "type": "text",
        "id": (_vm._uid + "-" + label),
        "placeholder": "default"
      },
      domProps: {
        "value": (validation.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(validation, "value", $event.target.value)
        }
      }
    }) : _vm._e(), (label === 'custom' && validation.active) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (validation.value),
        expression: "validation.value"
      }],
      attrs: {
        "type": "text",
        "id": (_vm._uid + "-" + label),
        "placeholder": "custom validation"
      },
      domProps: {
        "value": (validation.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(validation, "value", $event.target.value)
        }
      }
    }) : _vm._e()])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d84e386a!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/configuration/ValidationConfig.vue
// module id = 2550
// module chunks = 1